const RTL_LANGUAGE_CODES = new Set(["ar", "fa", "he", "ur"]);

export function localeDirection(locale?: string | null): "ltr" | "rtl" {
  const language = (locale || "en").split("-")[0].toLowerCase();
  return RTL_LANGUAGE_CODES.has(language) ? "rtl" : "ltr";
}
